module.exports = __webpack_public_path__ + "static/media/ocinsights.9e20a948.png";